import isObject from 'lodash/isObject';
import isString from 'lodash/isString';
export function isPathLike(value) {
    if ((value === null || value === void 0 ? void 0 : value.length) === 2 && isObject(value[1])) {
        return true;
    }
    if ((value === null || value === void 0 ? void 0 : value.route) || (value === null || value === void 0 ? void 0 : value.path)) {
        return true;
    }
    if (isString(value)) {
        return true;
    }
    return false;
}
